import React, { useState, useEffect } from "react";
import "./StatusBar.css";
import wifiIcon from "./wifi-off.svg";
import batteryIcon from "./battery-full.svg";
import signalIcon from "./cellular-data-off.svg";

const StatusBar: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="status-bar">
      <div className="time">
        {time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </div>
      <div className="status-icons">
        <img src={wifiIcon} alt="Wifi Icon" className="wifi-icon" />
        <img src={signalIcon} alt="Signal Icon" className="signal-icon" />
        <img src={batteryIcon} alt="Battery Icon" className="battery-icon" />
      </div>
    </div>
  );
};

export default StatusBar;
